import { useMemo } from "react";
import { IStyleFunctionOrObject } from "@fluentui/merge-styles/lib/IStyleFunction";
import { IDetailsColumnStyleProps, IDetailsColumnStyles } from "@fluentui/react/lib/DetailsList";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

import { textOverflow } from "Utils/Styles";

const classNames = {
  host: `UrlRendererHost`,
  root: `UrlRenderer`,
  icon: `UrlRendererIcon`
};

export function useUrlRendererStyles(styles?: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles>) {
  const { fonts } = useTheme();
  return useMemo(
    () => mergeStyleSets(
      {
        host: [classNames.host, {}],
        root: [
          classNames.root,
          {
            width: `100%`,
            ...textOverflow
          }
        ],
        icon: [
          classNames.icon,
          {
            fontSize: fonts.mediumPlus.fontSize,
            marginTop: `-6px`
          }
        ]
      },
      { host: styles }
    ),
    [fonts, styles]
  );
}
